import styles from '../searchBar.module.scss';

type Props = {
  query: string;
};

const EmptyState = ({ query }: Props) => (
  <div className={styles.emptyState}>
    <p className={styles.emptyStateTitle}>
      No results for <span className={styles.emptyStateQuery}>{query}</span>
    </p>
    <p className={styles.emptyStateHint}>
      Try a different keyword or browse our main pages.
    </p>
  </div>
);

export default EmptyState;
